import React, { FC } from 'react';
import { SectionType } from '@fdha/common-utils';

import ChooseMeals from './ChooseMeals';

// Component that renders the choose meals interface
export const ChooseMealsPageWithContext: FC<{
  patientId: string;
  subjectId?: string;
  deliveryMenuId: string;
  deliveryId: string;
  foodProgramUserId: string;
  itemType: SectionType;
  handleReviewSelection: () => void;
}> = ({
  patientId,
  subjectId,
  deliveryMenuId,
  deliveryId,
  foodProgramUserId,
  itemType,
  handleReviewSelection,
}) => {
  return (
    <ChooseMeals
      patientId={patientId}
      subjectId={subjectId}
      deliveryMenuId={deliveryMenuId}
      deliveryId={deliveryId}
      foodProgramUserId={foodProgramUserId}
      itemType={itemType}
      handleReviewSelection={handleReviewSelection}
    />
  );
};
